import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Message {
  sender: 'user' | 'bot';
  text: string;
}

interface ChatState {
  messages: Message[];
}

const initialState: ChatState = {
  messages: [
    {
      sender: 'bot',
      text: 'Xin chào. Bạn có muốn tôi phân tích chỉ số này không?',
    },
  ],
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<Message>) => {
      state.messages.push(action.payload);
    },
    resetMessages: (state) => {
      state.messages = initialState.messages;
    },
  },
});

export const { addMessage, resetMessages } = chatSlice.actions;
export default chatSlice.reducer;
